import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex justify-between items-baseline" }
const _hoisted_3 = { class: "text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col justify-between h-44 p-4", _ctx.coloreAttivo])
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.testoNotifica), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.date), 1),
      _withDirectives(_createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.markAsRead && _ctx.markAsRead(...args))),
        class: "text-xs hover:underline",
        href: "javascript:void(0)"
      }, "marca come letta", 512), [
        [_vShow, _ctx.mark_as_read]
      ]),
      _createVNode(_component_router_link, {
        to: _ctx.to,
        class: "underline flex justify-self-end text-sm"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Vedi")
        ])),
        _: 1
      }, 8, ["to"])
    ])
  ], 2))
}